"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7525],{

/***/ 15445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./public/dawn-logo.svg
var dawn_logo = __webpack_require__(54171);
// EXTERNAL MODULE: ./components/icons/IconFacebook.tsx
var IconFacebook = __webpack_require__(12337);
// EXTERNAL MODULE: ./components/icons/IconTwitter.tsx
var IconTwitter = __webpack_require__(22971);
;// CONCATENATED MODULE: ./components/icons/IconInstagram.tsx

function IconInstagram(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.053.072C8.333.013 8.74 0 12 0s3.668.014 4.946.072c1.279.058 2.151.262 2.915.557.8.303 1.525.775 2.125 1.386a5.862 5.862 0 011.383 2.124c.297.764.5 1.636.559 2.913C23.987 8.333 24 8.742 24 12c0 3.26-.014 3.668-.072 4.947-.058 1.277-.262 2.15-.559 2.913a5.887 5.887 0 01-1.383 2.126 5.885 5.885 0 01-2.125 1.383c-.764.297-1.636.5-2.913.559-1.28.059-1.688.072-4.948.072-3.26 0-3.668-.014-4.947-.072-1.277-.058-2.15-.262-2.913-.559a5.889 5.889 0 01-2.126-1.383 5.882 5.882 0 01-1.385-2.125c-.295-.764-.498-1.636-.557-2.913C.013 15.666 0 15.258 0 12c0-3.26.014-3.668.072-4.946.058-1.279.262-2.151.557-2.915.302-.8.775-1.526 1.386-2.125A5.882 5.882 0 014.139.629C4.903.334 5.775.131 7.052.072zm9.796 2.16c-1.265-.058-1.645-.07-4.849-.07s-3.584.012-4.85.07c-1.17.053-1.805.249-2.228.413-.56.219-.96.477-1.38.897a3.722 3.722 0 00-.897 1.38c-.164.423-.36 1.058-.413 2.229-.058 1.265-.07 1.645-.07 4.849s.012 3.584.07 4.85c.053 1.17.249 1.804.413 2.228.192.52.499.992.897 1.38.387.398.86.705 1.38.897.423.164 1.058.36 2.229.413 1.265.058 1.644.07 4.849.07s3.584-.012 4.85-.07c1.17-.053 1.804-.249 2.228-.413.56-.219.96-.477 1.38-.897.398-.387.705-.86.897-1.38.164-.424.36-1.058.413-2.229.058-1.265.07-1.645.07-4.849s-.012-3.584-.07-4.85c-.053-1.17-.249-1.805-.413-2.228a3.725 3.725 0 00-.897-1.38 3.723 3.723 0 00-1.38-.897c-.424-.164-1.058-.36-2.229-.413zm-6.382 13.467a4.002 4.002 0 004.364-6.53 4.003 4.003 0 10-4.364 6.53zM7.64 7.64a6.168 6.168 0 118.722 8.722A6.168 6.168 0 017.64 7.64zm11.897-.888a1.458 1.458 0 10-2-2.121 1.458 1.458 0 002 2.12z",
            fill: "#fff"
        })
    });
};

;// CONCATENATED MODULE: ./components/Footer/Footer.tsx








function Footer(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: classnames_default()("flex justify-center border-t border-white border-opacity-10", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center flex-1 px-10 py-8 max-w-9xl xl:flex-row xl:justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center xl:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-24 xl:mr-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "aria-label": "Back to main page",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: dawn_logo/* default */.Z,
                                        alt: "Dawn logo"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center flex-1 mt-8 space-y-8 text-sm leading-4 xl:text-base xl:flex-row xl:space-y-0 xl:space-x-14 xl:mt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/legal/terms-of-service",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Terms"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/legal/privacy-policy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Privacy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "https://www.notion.so/dawn-health/Dawn-Job-Board-c370eab65ee14522a716bc8fcbedd213",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Jobs"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:team@dawn.health",
                                    className: "font-medium tracking-widest text-white uppercase",
                                    children: "Contact"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#",
                                    className: "font-medium tracking-widest uppercase text-dawnDark-200",
                                    children: "\xa9 2023 Sleepedy, Inc"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center mt-6 space-x-12 text-white xl:mt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://www.facebook.com/dawnhealthapp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Facebook",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFacebook/* default */.Z, {
                                    className: "w-6 h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://twitter.com/dawnhealthapp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Twitter",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTwitter/* default */.Z, {
                                    className: "w-6 h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://www.instagram.com/dawnhealthapp/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Instagram",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconInstagram, {
                                    className: "w-6 h-6"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 1824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ Gradient; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/tailwindConfig.ts
var tailwindConfig = __webpack_require__(30049);
;// CONCATENATED MODULE: ./components/Gradient/Gradient.tsx


var tailwindColors = tailwindConfig/* theme */.r === null || tailwindConfig/* theme */.r === void 0 ? void 0 : tailwindConfig/* theme.colors */.r.colors;
var availableColors = {
    purple: tailwindColors["dawnPurple"]["500"],
    orange: tailwindColors["dawnOrange"]["500"]
};
function Gradient(param) {
    var color = param.color, _scale = param.scale, scale = _scale === void 0 ? 1 : _scale, _opacity = param.opacity, opacity = _opacity === void 0 ? 0.15 : _opacity, _right = param.right, right = _right === void 0 ? undefined : _right, _left = param.left, left = _left === void 0 ? undefined : _left, _top = param.top, top = _top === void 0 ? 0 : _top, _fixed = param.fixed, fixed = _fixed === void 0 ? false : _fixed;
    var width = 200;
    var height = 100;
    var selectedColor = availableColors[color];
    width = width * scale;
    height = height * scale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            right: right,
            left: left,
            top: top
        },
        className: "".concat(fixed ? "fixed" : "absolute", "  z-0 overflow-hidden"),
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                filter: "url(#filter)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    cx: "50%",
                    cy: "50%",
                    rx: "20%",
                    ry: "20%",
                    fill: selectedColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter",
                    x: "0",
                    y: "0",
                    width: width,
                    height: height,
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: Math.round(width * 0.07),
                            result: "effect1_foregroundBlur"
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Gradient/index.ts



/***/ }),

/***/ 12337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconFacebook; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function IconFacebook(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"
        })
    });
};


/***/ }),

/***/ 22971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconTwitter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function IconTwitter(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"
        })
    });
};


/***/ }),

/***/ 41697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ usePreviewSubscription; },
/* harmony export */   "i3": function() { return /* binding */ sanityClient; },
/* harmony export */   "vc": function() { return /* binding */ config; }
/* harmony export */ });
/* unused harmony export useCurrentUser */
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81035);

var config = {
    projectId: "4jrvqlog",
    dataset: "production",
    apiVersion: "2021-07-21",
    useCdn: "production" === "production"
};
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createPreviewSubscriptionHook */ .KF)(config);
var useCurrentUser = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createCurrentUserHook */ .Iy)(config);
var sanityClient = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .eI)(config);


/***/ }),

/***/ 47525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NQ": function() { return /* binding */ PostLibrary; }
});

// UNUSED EXPORTS: sharedGetStaticPaths, sharedGetStaticProps

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/sanity.ts
var sanity = __webpack_require__(41697);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(15445);
// EXTERNAL MODULE: ./modules/blog/PostPreview.tsx
var PostPreview = __webpack_require__(41438);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./utils/range.ts
var range = __webpack_require__(97191);
;// CONCATENATED MODULE: ./modules/blog/PostPagination.tsx



function BackArrow() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "stroke-current",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.5 4L8.5 12L16.5 20",
            strokeWidth: "2",
            strokeMiterlimit: "10"
        })
    });
}
function ForwardArrow() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "stroke-current",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.5 20L16.5 12L8.5 4",
            strokeWidth: "2",
            strokeMiterlimit: "10"
        })
    });
}
function PostPagination(param) {
    var pageNumber = param.pageNumber, numberOfPages = param.numberOfPages;
    pageNumber = Number(pageNumber);
    numberOfPages = Number(numberOfPages);
    var startRange = Math.max(1, pageNumber - 2);
    var endRange = Math.min(pageNumber + 3, numberOfPages + 1);
    var pageNavigation = (0,range/* range */.w)({
        start: startRange,
        end: endRange,
        step: 1
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between w-full max-w-sm text-lg md:justify-start md:space-x-16 md:text-2xl md:leading-10",
        children: [
            pageNumber !== 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/blog/page/".concat(pageNumber - 1),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackArrow, {})
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-dawnDark-300",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackArrow, {})
            }),
            pageNavigation.map(function(n) {
                if (n === pageNumber) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-medium text-dawnPurple-500",
                        children: n
                    }, n);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    href: "/blog/page/".concat(n),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: n
                    })
                }, n);
            }),
            pageNumber !== numberOfPages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/blog/page/".concat(Number(pageNumber) + 1),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardArrow, {})
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-dawnDark-300",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardArrow, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
;// CONCATENATED MODULE: ./modules/blog/PostLibrary.tsx










var POSTS_PER_PAGE = 7;
function PostLibrary(param) {
    var posts = param.posts, pageNumber = param.pageNumber, numberOfPages = param.numberOfPages, metaTitle = param.metaTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle || "Sleep Blog: Insomnia Tips and Resources | Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Your sleep is vital to us. Read about different insomnia types, tips for better sleep, and resources to learn about sleep treatments on Dawn Health\u2019s blog."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "overflow-hidden bg-dawnDark-700",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                        color: "purple",
                                        scale: 7,
                                        opacity: 0.25,
                                        left: "-50rem"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                        color: "orange",
                                        scale: 8,
                                        opacity: 0.1,
                                        left: "-50rem",
                                        top: "5rem"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                        color: "purple",
                                        scale: 7,
                                        opacity: 0.25,
                                        right: "-30rem",
                                        top: "-20rem"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                        color: "orange",
                                        scale: 7,
                                        opacity: 0.1,
                                        right: "-40rem",
                                        top: "-2rem"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center px-6 py-24",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostPreview/* PostPreviewFeatured */.sC, {
                                            post: posts[0]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center mx-6 mt-14 md:mt-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col pb-28 space-y-14 md:space-y-16 xl:space-y-20",
                            children: posts.slice(1, posts.length).map(function(post) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostPreview/* PostPreviewListItem */.rJ, {
                                    post: post
                                }, post._id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center pb-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostPagination, {
                            pageNumber: pageNumber,
                            numberOfPages: numberOfPages
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                        className: "bg-dawnDark-700"
                    })
                ]
            })
        ]
    });
}
function fetchNumberOfPosts() {
    return _fetchNumberOfPosts.apply(this, arguments);
}
function _fetchNumberOfPosts() {
    _fetchNumberOfPosts = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var countQuery, numberOfPosts, numberOfPages;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    countQuery = "count(*[_type == 'post' && defined(slug) && publishedAt < now()])";
                    _ctx.next = 3;
                    return sanityClient.fetch(countQuery);
                case 3:
                    numberOfPosts = _ctx.sent;
                    numberOfPages = Math.trunc(numberOfPosts / POSTS_PER_PAGE);
                    return _ctx.abrupt("return", {
                        numberOfPosts: numberOfPosts,
                        numberOfPages: numberOfPages
                    });
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchNumberOfPosts.apply(this, arguments);
}
function sharedGetStaticPaths() {
    return _sharedGetStaticPaths.apply(this, arguments);
}
function _sharedGetStaticPaths() {
    _sharedGetStaticPaths = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var numberOfPages, paths;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchNumberOfPosts();
                case 2:
                    numberOfPages = _ctx.sent.numberOfPages;
                    paths = Array.from({
                        length: Math.trunc(numberOfPages)
                    }, function(_, index) {
                        return {
                            params: {
                                pageNumber: (index + 1).toString()
                            }
                        };
                    });
                    return _ctx.abrupt("return", {
                        paths: paths,
                        fallback: false
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _sharedGetStaticPaths.apply(this, arguments);
}
function sharedGetStaticProps(_) {
    return _sharedGetStaticProps.apply(this, arguments);
}
function _sharedGetStaticProps() {
    _sharedGetStaticProps = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var params, ref, numberOfPosts, numberOfPages, pageNumber, postSliceStart, postSliceEnd, query, posts;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = param.params;
                    _ctx.next = 3;
                    return fetchNumberOfPosts();
                case 3:
                    ref = _ctx.sent;
                    numberOfPosts = ref.numberOfPosts;
                    numberOfPages = ref.numberOfPages;
                    pageNumber = Number(params.pageNumber - 1);
                    postSliceStart = pageNumber * POSTS_PER_PAGE;
                    postSliceEnd = postSliceStart + POSTS_PER_PAGE;
                    // If it's the last page, we add last chunk of posts that weren't enough for a full POSTS_PER_PAGE.
                    if (pageNumber + 1 === numberOfPages) {
                        postSliceEnd = postSliceEnd + numberOfPosts;
                    }
                    query = "*[_type == 'post' && defined(slug) && publishedAt < now()] | order(publishedAt desc)[".concat(postSliceStart, "...").concat(postSliceEnd, "]{ ... }");
                    _ctx.next = 13;
                    return sanityClient.fetch(query, {});
                case 13:
                    posts = _ctx.sent;
                    return _ctx.abrupt("return", {
                        props: {
                            posts: posts,
                            pageNumber: params.pageNumber,
                            numberOfPages: numberOfPages
                        }
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _sharedGetStaticProps.apply(this, arguments);
}


/***/ }),

/***/ 41438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qG": function() { return /* binding */ PostPreviewReadMore; },
/* harmony export */   "rJ": function() { return /* binding */ PostPreviewListItem; },
/* harmony export */   "sC": function() { return /* binding */ PostPreviewFeatured; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(504);
/* harmony import */ var modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88114);
/* harmony import */ var modules_blog_PostPublishedAtReadTime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51339);




function PostPreviewWrapper(param) {
    var children = param.children, post = param.post, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r, {
        href: "/blog/".concat(post.slug.current),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "flex cursor-pointer w-full max-w-sm group ".concat(className),
            children: children
        })
    });
}
function PostPreviewListItem(param) {
    var post = param.post;
    if (!post) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PostPreviewWrapper, {
        post: post,
        className: "flex flex-col w-full max-w-sm cursor-pointer md:flex-row md:items-center md:max-w-2xl xl:max-w-3xl md:space-x-6 group",
        children: [
            post.mainImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-full overflow-hidden rounded-xl md:w-1/3 h-44 xl:h-52",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        image: post.mainImage,
                        fill: true,
                        className: "transition duration-300 ease-in-out group-hover:transform group-hover:scale-110"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute hidden w-full h-full bg-white group-hover:block opacity-20"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 mt-6 md:mt-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_blog_PostPublishedAtReadTime__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        publishedAt: post.publishedAt,
                        readTime: post.readTime
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-xl font-semibold md:mt-2 xl:text-2xl xl:leading-8 group-hover:text-dawnPurple-500",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-base xl:text-xl xl:leading-8 font-inter max-h-24",
                        children: post.excerpt || "Missing excerpt"
                    })
                ]
            })
        ]
    });
}
function PostPreviewFeatured(param) {
    var post = param.post;
    if (!post) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PostPreviewWrapper, {
        post: post,
        className: "flex flex-col w-full max-w-sm cursor-pointer md:flex-row md:items-center md:max-w-3xl xl:max-w-5xl md:space-x-12 group",
        children: [
            post.mainImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-full overflow-hidden rounded-xl md:w-1/2 h-80 xl:h-100",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        image: post.mainImage,
                        fill: true,
                        className: "transition duration-300 ease-in-out group-hover:transform group-hover:scale-110"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute hidden w-full h-full bg-white group-hover:block opacity-20"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 mt-8 md:mt-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_blog_PostPublishedAtReadTime__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        publishedAt: post.publishedAt,
                        readTime: post.readTime
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-3xl font-semibold text-white xl:text-4xl xl:leading-12 group-hover:text-dawnPurple-500",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-white font-inter xl:text-xl xl:leading-8",
                        children: post.excerpt || "Missing excerpt"
                    })
                ]
            })
        ]
    });
}
function PostPreviewReadMore(param) {
    var post = param.post;
    if (!post) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PostPreviewWrapper, {
        post: post,
        className: "flex flex-col max-w-xs group",
        children: [
            post.mainImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-full overflow-hidden h-62 rounded-xl",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        image: post.mainImage,
                        fill: true,
                        className: "transition duration-300 ease-in-out group-hover:transform group-hover:scale-110"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute hidden w-full h-full bg-white group-hover:block opacity-20"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 mt-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_blog_PostPublishedAtReadTime__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        publishedAt: post.publishedAt,
                        readTime: post.readTime
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-4 text-xl font-semibold md:text-2xl group-hover:text-dawnPurple-500",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-4 text-base tracking-wide md:leading-8 md:text-lg font-inter",
                        children: post.excerpt || ""
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 51339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PostPublishedAtReadTime; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/esm/utcToZonedTime/index.js
var utcToZonedTime = __webpack_require__(47951);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/esm/format/index.js + 34 modules
var format = __webpack_require__(94559);
;// CONCATENATED MODULE: ./utils/date-utils.ts

var DEFAULT_DATE_FORMATS = {
    time: "h:mm a",
    date: "MMMM d, yyyy",
    dateDayMonth: "MMMM d",
    dateTime: "MMMM d, h:mm a",
    hour: "h a"
};
function dateParseISOFromTimezone(date) {
    var d = date.split(/\D/).map(function(d) {
        return parseInt(d);
    });
    return new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);
}
function dateFormat(date, options) {
    var formatStr;
    if (options === null || options === void 0 ? void 0 : options.formatStr) {
        // Try default formats first
        formatStr = DEFAULT_DATE_FORMATS[options.formatStr] ? DEFAULT_DATE_FORMATS[options.formatStr] : options.formatStr;
    } else {
        formatStr = DEFAULT_DATE_FORMATS.date;
    }
    if (options === null || options === void 0 ? void 0 : options.timeZone) {
        date = (0,utcToZonedTime/* default */.Z)(date, options.timeZone);
        return (0,format/* default */.Z)(date, formatStr, {
            timeZone: options.timeZone
        });
    }
    return (0,format/* default */.Z)(date, formatStr);
}

;// CONCATENATED MODULE: ./modules/blog/PostPublishedAtReadTime.tsx



function PostPublishedAtReadTime(param) {
    var publishedAt = param.publishedAt, readTime = param.readTime;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-sm font-medium tracking-widest uppercase md:text-base md:leading-4 text-dawnDark-300",
        children: [
            publishedAt ? dateFormat((0,parseISO/* default */.Z)(publishedAt), {
                formatStr: "MMM d, yyyy"
            }) : "",
            " \u2022 ",
            readTime || "",
            " min read"
        ]
    });
};


/***/ }),

/***/ 88114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SanityImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_sanity_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61202);
/* harmony import */ var lib_sanity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41697);






function SanityImage(param) {
    var image = param.image, className = param.className, _fill = param.fill, fill = _fill === void 0 ? false : _fill, _width = param.width, width = _width === void 0 ? 800 : _width, _sizes = param.sizes, sizes = _sizes === void 0 ? "(max-width: 800px) 100vw, 800px" : _sizes;
    var imageProps = (0,next_sanity_image__WEBPACK_IMPORTED_MODULE_2__/* .useNextSanityImage */ .J)(lib_sanity__WEBPACK_IMPORTED_MODULE_3__/* .sanityClient */ .i3, image, {
        imageBuilder: function(imageUrlBuilder, options) {
            return imageUrlBuilder.width(Math.min(width, options.width));
        }
    });
    return fill ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: imageProps.src,
        alt: image.alt,
        loader: imageProps.loader,
        layout: "fill",
        sizes: sizes,
        objectFit: "cover",
        className: className
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
        alt: image.alt,
        layout: "responsive",
        sizes: sizes,
        className: className
    }));
};


/***/ }),

/***/ 41125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var _object_spread = (__webpack_require__(50337)/* ["default"] */ .Z);
var _to_consumable_array = (__webpack_require__(53929)/* ["default"] */ .Z);
var defaultTheme = __webpack_require__(75874);
module.exports = {
    purge: [
        "./pages/**/*.{js,ts,jsx,tsx}",
        "./modules/**/*.{js,ts,jsx,tsx}",
        "./lib/**/*.{js,ts,jsx,tsx}",
        "./components/**/*.{js,ts,jsx,tsx}", 
    ],
    mode: "jit",
    darkMode: false,
    theme: {
        linearBorderGradients: function(theme) {
            return {
                colors: _object_spread({
                    "orange-purple": [
                        theme("colors.dawnOrange.500"),
                        theme("colors.dawnPurple.500")
                    ]
                }, theme("colors")),
                background: _object_spread({
                    white: theme("colors.white")
                }, theme("colors"))
            };
        },
        colors: {
            dawnDark: {
                100: "#EFF2F6",
                150: "#E5E5E5",
                200: "#BBBDC5",
                300: "#858992",
                400: "#4F555F",
                500: "#19212C",
                550: "#232832",
                600: "#151B25",
                700: "#11161E",
                800: "#0D1117",
                900: "#090C10"
            },
            dawnOrange: {
                100: "#FFEEE5",
                200: "#FFD7C4",
                300: "#FFBFA1",
                400: "#FFA77E",
                500: "#FF8F5B",
                600: "#C56E45",
                700: "#8C4C2E",
                800: "#532A17",
                900: "#1A0800"
            },
            dawnPurple: {
                100: "#E9EDFB",
                200: "#C5CDF4",
                300: "#9FADEE",
                400: "#798DE8",
                500: "#536DE2",
                600: "#4055AF",
                700: "#2C3B7C",
                800: "#182149",
                900: "#040716"
            },
            dawnRed: {
                500: "#E24328"
            },
            dawnGreen: {
                500: "#E24328"
            },
            white: "#fff",
            black: "#000",
            transparent: "transparent"
        },
        extend: {
            spacing: {
                1.5: "0.375rem",
                13: "3.25rem",
                18: "4.5rem",
                22: "5.5rem",
                26: "6.5rem",
                30: "7.5rem",
                34: "8.5rem",
                38: "9.5rem",
                62: "15.5rem",
                100: "25rem",
                108: "27rem",
                500: "31.25rem"
            },
            maxWidth: {
                "1.5xl": "38rem",
                "3.5xl": "52rem",
                "8xl": "88rem",
                "9xl": "96rem"
            },
            fontFamily: {
                sans: [
                    "Epilogue"
                ].concat(_to_consumable_array(defaultTheme.fontFamily.sans)),
                inter: [
                    "Inter"
                ].concat(_to_consumable_array(defaultTheme.fontFamily.sans))
            },
            fontSize: {
                "2.5xl": "1.75rem",
                "3.5xl": "2rem",
                "5.5xl": "3.5rem",
                "6.25xl": "4rem"
            },
            lineHeight: {
                12: "3rem",
                14: "3.5rem",
                18: "4.5rem"
            },
            zIndex: {
                "-10": "-10",
                "-05": "-05"
            },
            borderWidth: {
                1.5: "1.5px"
            },
            borderRadius: {
                dawnDefault: "2.5rem"
            },
            inset: {
                "60%": "60%"
            },
            backdropBlur: {
                "1.5xl": "2.25rem"
            },
            opacity: {
                6: "0.06"
            },
            maxHeight: {
                1000: "100rem"
            },
            typography: function(theme) {
                return {
                    DEFAULT: {
                        css: {
                            a: {
                                "word-break": "break-word",
                                "overflow-wrap": "break-word",
                                fontWeight: "normal",
                                "text-decoration": "none",
                                color: theme("colors.dawnPurple.500"),
                                "&:hover": {
                                    color: theme("colors.dawnPurple.600")
                                }
                            }
                        }
                    }
                };
            }
        }
    },
    plugins: [
        __webpack_require__(50130),
        __webpack_require__(54863),
        __webpack_require__(34270),
        __webpack_require__(2112), 
    ]
};


/***/ }),

/***/ 97191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ range; }
/* harmony export */ });
function range(param) {
    var start = param.start, end = param.end, _step = param.step, step = _step === void 0 ? 1 : _step;
    return Array.from(Array.from(Array(Math.ceil((end - start) / step)).keys()), function(x) {
        return start + x * step;
    });
}


/***/ }),

/***/ 30049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86926);
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tailwind_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41125);
/* harmony import */ var _tailwind_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config_js__WEBPACK_IMPORTED_MODULE_1__);


var theme = tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default()((_tailwind_config_js__WEBPACK_IMPORTED_MODULE_1___default())).theme;


/***/ })

}]);